export default __webpack_public_path__ + "static/pragicts-ai-banner-automation-c6d6622d0c102f36ad6a683e94c574c6.jpg";